/**
 * Atlas PM · 系统设置 · 任务形态字典 · 接口封装
 *
 * 对接后端 DictController（apps/api/src/modules/dict/dict.controller.ts）：
 *   GET    /system/task-categories        列表（含停用项，需 dict:manage）
 *   POST   /system/task-categories        新建
 *   PATCH  /system/task-categories/:id    编辑（code 由服务层忽略，不可改）
 *   DELETE /system/task-categories/:id    删除（有引用返回 409 DICT_IN_USE）
 *
 * ⚠️ 实际路径由 api/client 补 `/api` 前缀 → `/api/system/task-categories`。
 */

import { api } from '../../../api/client';

/* ── 领域类型（与后端 TaskCategoryItem 对齐，id 统一为字符串） ── */

export interface TaskCategoryItem {
  id: string;
  code: string;
  name: string;
  color: string | null;
  /** ⭐ P8.9 备注说明（选填） */
  description: string | null;
  sortOrder: number;
  isActive: boolean;
  createdAt: string;
}

/** 编辑入参；code 由服务层忽略 */
export interface TaskCategoryUpdateInput {
  name?: string;
  color?: string | null;
  /** 备注说明，空串表示清空（后端存 NULL） */
  description?: string | null;
  sortOrder?: number;
  isActive?: boolean;
}

/** 新建入参；name 必填，code 不传则由服务端自动生成唯一值（P6.35） */
export interface TaskCategoryCreateInput extends TaskCategoryUpdateInput {
  code?: string;
  name: string;
}

/* ── 接口方法 ── */

const BASE = '/system/task-categories';

export const taskCategoryApi = {
  list: () => api.get<TaskCategoryItem[]>(BASE),
  create: (input: TaskCategoryCreateInput) => api.post<TaskCategoryItem>(BASE, input),
  update: (id: string, input: TaskCategoryUpdateInput) =>
    api.patch<TaskCategoryItem>(`${BASE}/${id}`, input),
  remove: (id: string) => api.delete<{ ok: true; id: string }>(`${BASE}/${id}`),
};
